import baseHttp from './baseHttp';

export const getOrders = (restaurantId, params) =>
  baseHttp.get(`/api/v1/order/restaurants/${restaurantId}/mobile`, { params }).then((r) => r.data);

export const getOrderDetail = (orderId) =>
  baseHttp.get(`/api/v1/order/${orderId}`).then((r) => r.data);

// Paginated order history (date range, status, ref search) — partner dashboard.
export const getOrdersHistory = (restaurantId, params) =>
  baseHttp.get(`/api/v1/order/restaurants/${restaurantId}/history`, { params }).then((r) => r.data);

export const updateOrderStatus = (orderId, statusId, preparationTime) =>
  baseHttp.post(`/api/v1/order/${orderId}/status`, {
    status_id: statusId,
    ...(preparationTime != null ? { estimated_preparation_time: preparationTime } : {}),
  }).then((r) => r.data);

export const markOrderReady = (orderId) =>
  baseHttp.post(`/api/v1/order/${orderId}/ready`).then((r) => r.data);

export const cancelOrder = (orderId, cancellation) =>
  baseHttp.post(`/api/v1/order/${orderId}/cancel`, typeof cancellation === "string" ? { raison: cancellation } : cancellation).then((r) => r.data);

export const setPreparationTime = (orderId, minutes) =>
  baseHttp.post(`/api/v1/order/${orderId}/preparation-time`, {
    estimated_preparation_time: minutes,
  }).then((r) => r.data);

export const getUnconfirmedCount = (restaurantId) =>
  baseHttp.get('/api/v1/order/unconfirmed/count', {
    params: restaurantId ? { restaurant_id: restaurantId } : {},
  }).then((r) => r.data);

// ── Product editing (only allowed before confirmation, status_id < 2) ────────

export const addOrderProduct = (orderId, productId, payload) =>
  baseHttp.post(`/api/v1/order/${orderId}/product/${productId}`, payload).then((r) => r.data);

export const updateOrderProduct = (orderId, orderProductId, payload) =>
  baseHttp.put(`/api/v1/order/${orderId}/product/${orderProductId}`, payload).then((r) => r.data);

export const deleteOrderProduct = (orderId, orderProductId) =>
  baseHttp.delete(`/api/v1/order/${orderId}/product/${orderProductId}`).then((r) => r.data);
